import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDeepEqualsPureService } from 'ngx-deep-equals-pure';
import { environment } from '@environments/environment';
import { AdrenoCommonModule } from '@adreno-common';
import { NgxUploaderModule } from 'ngx-uploader';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    PerfectScrollbarModule,
    NgSelectModule,
    AdrenoCommonModule.forRoot(environment),
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    PerfectScrollbarModule,
    NgSelectModule,
    AdrenoCommonModule,
    NgxUploaderModule,
  ],
  providers: [NgxDeepEqualsPureService],
})
export class SharedModule {}
